import { Tabs as KitTabs, TabsList, TabsTab } from '@d-edge/overnight-hotelier-react'
import styles from './ui.module.css'

interface TabsProps<T extends string> {
  tabs: { id: T; label: string }[]
  value: T
  onChange: (id: T) => void
}

/** Tab strip only; the caller renders the active panel from `value`. */
export function Tabs<T extends string>({ tabs, value, onChange }: TabsProps<T>) {
  const index = Math.max(0, tabs.findIndex((tab) => tab.id === value))
  return (
    <KitTabs defaultIndex={index} className={styles.tabs}>
      <TabsList>
        {tabs.map((tab) => (
          <TabsTab key={tab.id} onClick={() => onChange(tab.id)} onFocus={() => onChange(tab.id)}>
            {tab.label}
          </TabsTab>
        ))}
      </TabsList>
    </KitTabs>
  )
}
